import { Product } from '../Catalog/Product';

export class ValidationRequest {

  constructor(
    public field?: string,
    public product?: Product,
    public methodId?: string,
    public systemKey?: string,
    public elementKey?: string,
    public booleanRadioGroupValue?: boolean,
    public isBooleanRadioGroup?: boolean
  ) {

  }
}
